window.dataLayer = window.dataLayer || []
const { cartCurrency, template } = document.querySelector('body').dataset

/**
 * ----------------------------------
 * Form events
 * ----------------------------------
 */
addGaFormEventListeners()

function addGaFormEventListeners () {
  document.querySelectorAll('[data-ga-el="form"]').forEach(form => {
    form.addEventListener('submit', e => {
      window.dataLayer.push({
        event: e.currentTarget.dataset.gaEvent,
        formSubmit: {
          form_name: e.currentTarget.dataset.gaName,
          submit_state: 'Successful',
        },
      })
    })
  })
}

const loginFormSubmitEl = document.querySelector('[data-ga-el="loginFormSubmit"]')
if (loginFormSubmitEl) {
  loginFormSubmitEl.addEventListener('click', () => {
    sessionStorage.setItem('loginFormSubmitted', 'true')
  })
}

if (template === 'account') {
  const isLoginReferal = sessionStorage.getItem('loginFormSubmitted')

  if (isLoginReferal) {
    sessionStorage.removeItem('loginFormSubmitted')

    window.dataLayer.push({
      event: 'login_account_submission',
      formSubmit: {
        form_name: 'login_account_form',
        submit_state: 'Successful',
      },
    })
  }
}

window.addEventListener('GA_ADD_TO_CART', event => {
  const { formName, item, index } = event.detail

  if (!formName || !item) return

  window.dataLayer.push({
    event: 'add_to_cart_form',
    dlv: {
      target_context: formName,
      target_index: index || null,
      item_id: item.product_id,
      item_title: item.title,
      item_handle: item.handle,
      item_variant: item.variant_title,
      item_price: item.price % 1 !== 0 ? item.price / 100 : item.price,
      item_discounted: item.discounted_price % 1 !== 0 ? item.discounted_price / 100 : item.discounted_price,
    },
  })
})

/**
 * ----------------------------------
 * Header events
 * ----------------------------------
 */

/**
 * @description: Tracks Site Header Wishlist Link Interaction
 */
if (document.querySelector('[data-ga-el="headerWishlistLink"]')) {
  document.querySelector('[data-ga-el="headerWishlistLink"]').addEventListener('click', e => {
    window.dataLayer.push({
      event: 'header_wishlist_click',
    })
  })
}

/**
 * @description: Tracks Site Header Account Link Interaction
 */
const accountLinkEls = document.querySelectorAll('[data-ga-el="accountLink"]')
if (accountLinkEls.length > 0) {
  accountLinkEls.forEach(element => {
    element.addEventListener('click', event => {
      window.dataLayer.push({
        event: 'header_account_click',
      })
    })
  })
}

/**
 * @description: Top Nav Link Click
 */
const topNavLinkEls = document.querySelectorAll('[data-ga-el="desktopNavLink"]')
topNavLinkEls.forEach(linkEl => {
  linkEl.addEventListener('click', event => {
    const linkAnchorEl = event.target.closest('[data-ga-el="desktopNavLink"]')

    const linkType = linkAnchorEl.dataset.gaNavLinkType
    const linkIndex = linkAnchorEl.dataset.gaNavLinkIndex
    const navParent = linkAnchorEl.dataset.gaNavParent
    const clickUrl = linkAnchorEl.dataset.gaClickUrl
    const clickText = linkAnchorEl.dataset.gaClickText

    window.dataLayer.push({
      event: 'desktop_nav_link_click',
      desktopNavLinkClick: {
        nav_link_type: linkType,
        nav_link_index: linkIndex,
        nav_parent: navParent,
        click_url: clickUrl,
        click_text: clickText,
      },
    })
  })
})

/**
 * @description: Nav Link Click Mobile
 */
const mobileNavLinkEls = document.querySelectorAll('[data-ga-el="mobileNavLink"]')
mobileNavLinkEls.forEach(linkEl => {
  linkEl.addEventListener('click', event => {
    const linkAnchorEl = event.target.closest('[data-ga-el="mobileNavLink"]')

    const linkType = linkAnchorEl.dataset.gaNavLinkType
    const linkIndex = linkAnchorEl.dataset.gaNavLinkIndex
    const navParent = linkAnchorEl.dataset.gaNavParent
    const clickUrl = linkAnchorEl.dataset.gaClickUrl
    const clickText = linkAnchorEl.dataset.gaClickText

    window.dataLayer.push({
      event: 'mobile_nav_link_click',
      mobileNavLinkClick: {
        nav_link_type: linkType,
        nav_link_index: linkIndex,
        nav_parent: navParent,
        click_url: clickUrl,
        click_text: clickText,
      },
    })
  })
})

/**
 * @description: Mobile Nav Trigger Click
 */
const mobileNavDrawerTriggers = document.querySelectorAll('[data-ga-el="mobile-nav-toggle"]')
mobileNavDrawerTriggers.forEach(trigerEl => {
  trigerEl.addEventListener('click', event => {
    const trigerAnchorEl = event.target.closest('[data-ga-el="mobile-nav-toggle"]')
    const clickAction = trigerAnchorEl.dataset.gaClickAction

    window.dataLayer.push({
      event: 'mobile_nav_trigger_click',
      mobileNavTriggerClick: {
        click_action: clickAction,
      },
    })
  })
})

/**
 * @description: Quick search
 */
const searchInputEls = document.querySelectorAll('[data-ga-el="searchInput"]')
if (searchInputEls.length > 0) {
  searchInputEls.forEach(inputEl => {
    inputEl.addEventListener('click', () => {
      watchForFindifyAutocompleteWrapper()
    })
  })
}

function watchForFindifyAutocompleteWrapper () {
  const observerConfig = {
    childList: true,
    subtree: true,
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const findifyContainer = document.querySelector('[data-findify-autocomplete-wrapper="true"]')

        if (findifyContainer) {
          findifyContainer.addEventListener('click', e => {
            pushSearchSuggestionEvent(e.target)
          })
          observer.disconnect()
        }
      }
    })
  })

  observer.observe(document.body, observerConfig)
}

function pushSearchSuggestionEvent (target) {
  const selectorClass = '.findify-components-autocomplete'
  const activeInput = [...searchInputEls].filter(input => input.value.length > 0)

  let clickAction = ''
  if (target.closest(`${selectorClass}--tip__wrapper`)) {
    clickAction = 'view_all'
  } else if (target.closest(`${selectorClass}--suggestions`)) {
    clickAction = 'suggestions'
  } else if (target.closest(`${selectorClass}--content`)) {
    clickAction = 'categories'
  }

  if (clickAction === '') return

  window.dataLayer.push({
    event: 'search_suggestion_click',
    searchSuggestionClick: {
      term: activeInput[0].value,
      click_action: clickAction,
      click_url: target.href || '',
      click_text: target.innerText || '',
    },
  })
}

/**
 * @description: Product Card Carousel
 */

if (document.querySelector('[data-ga-el="imageSlide"]')) {
  document.querySelectorAll('[data-ga-el="imageSlide"]').forEach(slide => {
    let isThrottled = false
    const throttleInterval = 2000 // Throttle interval in milliseconds

    slide.addEventListener('touchmove', (event) => {
      if (!isThrottled) {
        const currentTarget = event.currentTarget
        const productName = currentTarget.dataset.gaVariableProduct
        const slideIndex = currentTarget.dataset.gaElIndex + 1

        // Run your callback function here
        window.dataLayer.push({
          event: 'gallery_image_swipe_plp',
          productCardSwipe: {
            product_name: productName,
            slide_index: slideIndex,
          },
        })

        // Set throttled state
        isThrottled = true

        // Schedule next execution
        setTimeout(() => {
          isThrottled = false
        }, throttleInterval)
      }
    })
  })
}

/**
 * ----------------------------------
 * Footer events
 * ----------------------------------
 */

/**
 * @description: Footer Click
 */
const footerLinks = document.querySelectorAll('[data-ga-el="footerMenuLink"]')
if (footerLinks.length > 0) {
  footerLinks.forEach(footerLink => {
    footerLink.addEventListener('click', e => {
      const clickText = e.currentTarget.dataset.gaFooterLinkText
      const clickUrl = e.currentTarget.dataset.gaFooterLinkUrl
      const navParent = e.currentTarget.dataset.gaFooterLinkParent

      window.dataLayer.push({
        event: 'footer_link_click',
        footerLinkClick: {
          nav_parent: navParent,
          click_url: clickUrl,
          click_text: clickText,
        },
      })
    })
  })
}

/**
 * ----------------------------------
 * Minicart events
 * ----------------------------------
 */
/**
 * @description: Mini Cart Recs click
 */
function handleMiniCartRecsClick () {
  const miniCartRecommendationLinkEls = document.querySelectorAll('[data-ga-el="miniCartRecommendations"] [data-ga-el="productCardLink"]')

  miniCartRecommendationLinkEls.forEach(linkEl => {
    linkEl.addEventListener('click', event => {
      const productCardEl = event.target.closest('[data-ga-el="product-card"]')
      const productHandle = productCardEl.dataset.gaProductHandle
      const placementName = productCardEl.dataset.gaPlacement
      const itemIndex = productCardEl.dataset.gaIndex

      pushProductCardClickEvent(placementName, productHandle, itemIndex)
    })
  })
}

/**
 * @description: Mini Cart open/close
 */
window.document.addEventListener('fostrOffCanvasMenuEvent', (event) => {
  const { menuHTMLObject, action } = event.detail

  if (menuHTMLObject.id !== 'mini-cart') return

  if (action === 'open') {
    handleMiniCartRecsClick()

    let origin = ''
    switch (event.detail.origin) {
      case 'cart-items':
        origin = 'product-add'
        break
      case 'offcanvas-menu':
        origin = 'trigger-click'
        break
    }

    window.dataLayer.push({
      event: 'minicart_popup_open_event',
      minicartOpen: {
        open_method: origin,
      },
    })
  } else if (action === 'close') {
    window.dataLayer.push({
      event: 'minicart_popup_close_event',
    })
  }
})

/**
 * @description: Track empty mincart recommendations click
 */
const emptyMinicartRecsSlide = document.querySelectorAll('[data-ga-el="emptyMinicartRecs"]')
if (emptyMinicartRecsSlide.length > 0) {
  emptyMinicartRecsSlide.forEach(slide => {
    slide.addEventListener('click', event => {
      const slideEl = event.target.closest('[data-ga-el="emptyMinicartRecs"]')
      const { gaItem, gaType, gaIndex } = slideEl.dataset

      window.dataLayer.push({
        event: 'empty_minicart_recs_click',
        emptyMinicartRecClick: {
          item: gaItem,
          type: gaType,
          index: gaIndex,
        },
      })
    })
  })
}

/**
 * @description: Track mincart concierge form submit
 */
const conciergeFormSubmitEl = document.querySelector('[data-ga-el="minicart-concierge-submit"]')
if (conciergeFormSubmitEl) {
  conciergeFormSubmitEl.addEventListener('click', () => {
    window.dataLayer.push({
      event: 'minicart_concierge_submit',
    })
  })
}

/**
 * ----------------------------------
 * Other events
 * ----------------------------------
 */

/**
 * @description: Tagalys elements
 */
const tagalysElements = document.querySelectorAll('.tagalys-carousel-container')
if (tagalysElements.length) {
  [...tagalysElements].forEach(element => {
    const observer = new MutationObserver((mutations, observer) => {
      addListenersToTagalysSection(mutations[0].target)
      observer.disconnect()
    })

    observer.observe(element, { childList: true, subtree: true })
  })
}

function addListenersToTagalysSection (element) {
  const carouselEl = element.querySelector('slider-component')

  if (carouselEl) {
    carouselEl.addEventListener('click', trackTagalysRecsCarousels)
  }
}

function trackTagalysRecsCarousels (event) {
  const target = event.target
  const targetContext = target.closest('[data-gtm-target-context]')

  if (!targetContext) return

  const isArrowClick = target.closest('.slider-buttons')
  const isProductCardClick = target.closest('a.tagalys-prod-info') || target.closest('a.img-container')
  const isAddToCart = target.closest('.tagalys-atc-outer')

  let eventAction = ''
  if (isArrowClick) {
    eventAction = 'Arrow click'
  } else if (isProductCardClick) {
    eventAction = 'Product card click'
  } else if (isAddToCart) {
    eventAction = 'Add to cart'
  } else {
    eventAction = 'Drag'
  }

  window.dataLayer.push({
    event: 'tagalys_recs_interaction',
    dlv: {
      target_context: targetContext.dataset.gtmTargetContext,
      event_action: eventAction,
    },
  })
}

/**
 * @description: Product Card Click
 */
function handleProductCardClick () {
  const productCardLinkEls = document.querySelectorAll('[data-ga-el="productCardLink"]')

  productCardLinkEls.forEach(linkEl => {
    linkEl.addEventListener('click', event => {
      const productCardEl = event.target.closest('[data-ga-el="product-card"]')
      const productHandle = productCardEl.dataset.gaProductHandle
      const placementName = productCardEl.dataset.gaPlacement
      const itemIndex = productCardEl.dataset.gaIndex

      pushProductCardClickEvent(placementName, productHandle, itemIndex)
    })
  })
}

handleProductCardClick()

window.addEventListener('MINICART_RECOMMENDATIONS_RENDERED', event => {
  handleProductCardClick()
})

function pushProductCardClickEvent (placementName, productHandle, itemIndex) {
  fetch(`${window.Shopify.routes.root}products/${productHandle}.js`)
    .then(response => response.json())
    .then(product => {
      window.dataLayer.push({
        event: 'product_card_click',
        productCardClick: {
          placement_name: placementName,
          item_index: itemIndex,
          item: {
            product_id: product.id,
            title: product.title,
            handle: product.handle,
            price: product.price / 100,
            discounted_price: product.compare_at_price,
            in_stock: product.available,
          },
        },
      })
    })
}

/**
 * @description: Colour swatch click
 */
window.addEventListener('GA_SWATCHES_LOADED', (event) => {
  const swatchesEl = event.detail.swatchesEl
  const swatchEls = swatchesEl?.querySelectorAll('[data-ga-el="colourSwatch"]')

  if (!swatchEls.length) return

  swatchEls.forEach(swatchEl => {
    swatchEl.addEventListener('click', event => {
      window.dataLayer.push({
        event: 'colour_swatch_click',
        dlv: {
          target_text: event.currentTarget.dataset.gaColourSelected,
        },
      })
    })
  })
})

/**
 * @description: Add to wishlist
 */
window.addEventListener('WISHLIST_ADD_PRODUCT', event => {
  const productId = event.detail.productId
  const productTitle = event.detail.productTitle
  const productPrice = event.detail.productPrice

  window.dataLayer.push({
    event: 'add_to_wishlist',
    ecommerce: {
      currency: cartCurrency,
      value: parseInt(productPrice),
      items: [
        {
          item_id: productId,
          item_name: productTitle,
        },
      ],
    },
  })
})

/**
 * @description: Remove from wishlist
 */
window.addEventListener('WISHLIST_REMOVE_PRODUCT', event => {
  const productId = event.detail.productId
  const productTitle = event.detail.productTitle
  const productPrice = event.detail.productPrice

  window.dataLayer.push({
    event: 'remove_from_wishlist',
    dlv: {
      item_value: parseInt(productPrice),
      item_id: productId,
      item_title: productTitle,
    },
  })
})

/**
 * @description: Add to wishlist abort
 */
const closeWishlistModalEl = document.querySelector("[data-ga-el='wishlistAbort']")
if (closeWishlistModalEl) {
  closeWishlistModalEl.addEventListener('click', (event) => {
    const action = event.target.closest('[data-ga-action]').dataset.gaAction

    window.dataLayer.push({
      event: 'add_to_wishlist_abort',
      addToWishlistAbort: {
        action,
      },
    })
  })
}

/**
 * @description: Homepage click
 */
if (template && template === 'index') {
  const sections = document.querySelectorAll('#MainContent .shopify-section')

  sections.forEach(section => {
    section.addEventListener('click', event => {
      const target = event.target
      const clickedLinkEl = target.closest('a[href]')

      if (!clickedLinkEl) return

      const sectionWrapperEl = target.closest('#MainContent .shopify-section')
      const sectionOffsets = [...sections].map(section => section.offsetTop)
      const sectionIndex = sectionOffsets.indexOf(sectionWrapperEl.offsetTop)
      const sectionName = [...sectionWrapperEl.classList].filter(className => className !== 'shopify-section')

      window.dataLayer.push({
        event: 'homepage_section_click',
        dlv: {
          target_index: `${sectionIndex + 1}`,
          target_context: sectionName.length ? sectionName[0] : 'shopify-section',
          target_url: clickedLinkEl.href,
        },
      })
    })
  })
}
